import styled from 'styled-components';
import { FaTwitter, FaLinkedinIn, FaFacebook, FaInstagram } from 'react-icons/fa';
import bg14 from '../images/bg14.png';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  
  return (
  <FooterContainer>
     <FooterGlow />
    <Grid>
      <Column>
        <h3>DataVision Solutions</h3>
        <p>contact@datavision.com</p>
      </Column>
      <Column>
        <h3>Coordonnées</h3>
        <p>Avenue des Archères<br/><br />Belgique</p>
      </Column>

        {/* Entreprise */}
      <Column>
        <h3>Entreprise</h3>
        <p>
   <FooterLink onClick={() => navigate('/about')}>Qui sommes-nous</FooterLink><br /><br />
   <FooterLink onClick={() => navigate('/services')}>Services</FooterLink><br /><br />
   <FooterLink onClick={() => navigate('/contact')}>Contact</FooterLink>
 </p>
      </Column>
      <Column>
        <h3>Legal</h3>
        <p>Mentions légales<br /> <br /> Politique de confidentialité</p>
      </Column>
    </Grid>

    <Divider />
    <SocialContainer>
      <Copyright>
        © 2024 DataVision Solutions. Tous droits réservés.
      </Copyright>
      <SocialIcons>
      <a href="#" aria-label="Twitter">
          <FaTwitter size={20} />
        </a>
        <a href="#" aria-label="LinkedIn">
          <FaLinkedinIn size={20} />
        </a>
        <a href="#" aria-label="Facebook">
          <FaFacebook size={20} />
        </a>
        <a href="#" aria-label="Instagram">
          <FaInstagram size={20} />
        </a>
      </SocialIcons>
    </SocialContainer>

  </FooterContainer>
 );
};

export default Footer;


const FooterContainer = styled.footer`
 background: linear-gradient(to bottom, #000000 0%, #000033 100%);
 padding: 3rem 2rem;
 margin-top: 4rem;  
`;

// Optionnellement, ajoutez un effet de glow
const FooterGlow = styled.div`
 position: absolute;
 top: 0;
 left: 0;
 right: 0;
 height: 100px;
 background: radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 255, 0.1) 0%, rgba(0, 0, 0, 0) 100%);
 pointer-events: none;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Column = styled.div`
  h3 {
    margin-bottom: 1rem;
  }

  p, a {
    color: #94a3b8;
    text-decoration: none;
    margin-bottom: 0.5rem;
  }
`;



const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 2rem 0;
`;

const SocialContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  margin-top: 2rem;
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1.5rem;

  a {
    color: #94a3b8;
    transition: color 0.3s ease;
    
    &:hover {
      color: #60a5fa;
    }
  }
`;

const Copyright = styled.p`
  color: #94a3b8;
  font-size: 0.875rem;
`;

const FooterLink = styled.span`
 cursor: pointer;
 transition: color 0.3s ease;
 color: #94a3b8;

 &:hover {
   color: #60a5fa;
 }
`;